import { Tag } from 'antd';

const STATUS_MAP = {
    0: { label: 'Unavailable', color: 'red' },
    1: { label: 'Available', color: 'cyan' },
    2: { label: 'Reserved', color: 'green' },
};

/**
 * @param {object} props
 * @param {number} props.status - The status code to display.
 * @returns
 */
function TagStatus({ status, style }) {
    const { label, color } = STATUS_MAP[status] || {
        label: 'Unknown',
        color: 'default',
    };

    return (
        <Tag style={{ ...style }} color={color}>
            {label}
        </Tag>
    );
}

export default TagStatus;
